import { GroupAnimation } from './types';
import person1 from '../../../../assets/animations/metro/persons/person1.json';
import person2 from '../../../../assets/animations/metro/persons/person2.json';
import person3 from '../../../../assets/animations/metro/persons/person3.json';
import person4 from '../../../../assets/animations/metro/persons/person4.json';
import person5 from '../../../../assets/animations/metro/persons/person5.json';
import person6 from '../../../../assets/animations/metro/persons/person6.json';
import person7 from '../../../../assets/animations/metro/persons/person7.json';
import person8 from '../../../../assets/animations/metro/persons/person8.json';
import person9 from '../../../../assets/animations/metro/persons/person9.json';
import person10 from '../../../../assets/animations/metro/persons/person10.json';

export const animationMap: Record<number, any> = {
  1: person1,
  2: person2,
  3: person3,
  4: person4,
  5: person5,
  6: person6,
  7: person7,
  8: person8,
  9: person9,
  10: person10,
};

// Функция для перемешивания массива (алгоритм Fisher-Yates)
const shuffleArray = (array: number[]): number[] => {
  for (let i = array.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [array[i], array[j]] = [array[j], array[i]];
  }
  return array;
};

export const calculateGroups = (
  initialPeople: number, // Начальное количество людей в метро
  groupSizeRange: [number, number], // Диапазон размера группы
  id: number,
): { animation: GroupAnimation; finalPeopleCount: number } => {
  let peopleInMetro = initialPeople;

  // Генерация размера группы
  const groupSize = Math.floor(Math.random() * (groupSizeRange[1] - groupSizeRange[0] + 1) + groupSizeRange[0]);

  // Определение направления группы
  let direction: 'in' | 'out';
  if (peopleInMetro < groupSize) {
    direction = 'in'; // Если в метро меньше людей, чем размер группы, группа заходит
  } else {
    direction = Math.random() < 0.5 ? 'in' : 'out'; // Случайное направление
  }

  // Обновление количества людей в метро
  if (direction === 'in') {
    peopleInMetro += groupSize;
  } else {
    peopleInMetro -= groupSize;
  }

  // Создание массива чисел от 1 до animationFilesCount
  const allPersonIds = Array.from({ length: Object.keys(animationMap).length }, (_, i) => i + 1);

  // Перемешиваем массив и выбираем первые groupSize элементов
  const personIds = shuffleArray(allPersonIds).slice(0, groupSize);

  return {
    animation: {
      direction,
      size: groupSize,
      id,
      personIds, // Добавляем массив personIds в результат
    },
    finalPeopleCount: peopleInMetro, // Возвращаем итоговое количество людей в метро
  };
};
